import { setActiveTab } from "../actions/Migration";

let initialState = {
  sfAuth: '',
  hsAuth: '',
  hsAuthSource: '',
  pipedriveAuth: '',
  errors: [],
  results: [],
  modalObj: {},
  activeTab: 0,
  migration: {},
  migrations: [],
  resultPages: [],
  recordCount: 0,
  stripeSecret: {},
  nameModal: false,
  errorMessage: '',
  paymentStatus: '',
  downloadFields: '',
  totalRecords: '',
  supportedObjects: [],
  newDeltaMigration: {},
  objectsFieldMapping: {},
  attachmentsImportStatus: null, // null = not started, 'pending' | 'processing' | 'complete' | 'error'
  autoFixResult: null, // { loading, propertyName, added, removed, resolvedCount, message, error }
  resuming: false,
};

const Migration = (state = initialState, { type, payload }) => {

  switch (type) {
    case 'SET_MIGRATION':
      if (payload['type'] === 'redirect') window.location.replace(`/NewMigration?key=${payload['data']['key']}`);
      return {
        ...state,
        migration: payload['data'],
        sfAuth: payload['data']['sfAuth'],
        hsAuth: payload['data']['hsAuth'],
        pipedriveAuth: payload['data']['pipedriveAuth'],
        errors: payload['data']['errors'],
        results: payload['data']['results'],
        resultPages: payload['data']['resultPages'],
        totalRecords: payload['data']['resultTotal'],
        stripeSecret: payload['data']['stripeSecret'],
      };

    case 'SET_MIGRATIONS':
      return {
        ...state,
        sfAuth: payload['sfAuth'],
        hsAuth: payload['hsAuth'],
        hsAuthSource: payload['hsAuthSource'],
        pipedriveAuth: payload['pipedriveAuth'],
        migrations: payload['migrations'],
      };

    case 'SET_DOWNLOAD_CSV':
      return {
        ...state,
        downloadFields: payload
      };

    case 'SET_FIELDS_MAPPING':
      return {
        ...state,
        objectsFieldMapping: payload
      };

    case 'SET_RESUMING':
      return {
        ...state,
        resuming: payload
      };

    case 'SET_SUPPORTED_OBJECTS':
      return {
        ...state,
        supportedObjects: payload
      };

    case 'SET_MODAL_OBJ':
      return {
        ...state,
        modalObj: payload // title, body, type = 'Confirm', 'Acknowledge'
      };

    case 'SET_RESULTS':
      return {
        ...state,
        results: payload,
      };

    case 'SET_RESULT_PAGES':
      return {
        ...state,
        resultPages: payload,
      };

    case 'SET_RESULT_TOTAL':
      return {
        ...state,
        totalRecords: payload,
      };

    case 'SET_ERRORS':
      return {
        ...state,
        errors: payload,
      };

    case 'SET_AUTOFIX_RESULT':
      return {
        ...state,
        autoFixResult: payload,
      };

    case 'APPLY_ERRORS_RESOLVED': {
      // Optimistically flip `resolved` on matching error docs (by _id) inside errors.extraction /
      // errors.insertion so the Errors tab updates instantly without a refetch.
      const ids = new Set((payload['ids'] || []).map(String));
      const resolved = payload['resolved'] !== false;
      if (!ids.size || !state['errors'] || Array.isArray(state['errors'])) return state;
      const patchGroups = (groups) => (groups || []).map(g => ({
        ...g,
        errors: (g['errors'] || []).map(e => ids.has(String(e['_id'])) ? { ...e, resolved } : e),
      }));
      return {
        ...state,
        errors: {
          ...state['errors'],
          extraction: patchGroups(state['errors']['extraction']),
          insertion: patchGroups(state['errors']['insertion']),
        },
      };
    }

    case 'UPDATE_ERROR_POPUP':
      return {
        ...state,
        errorMessage: payload,
      };

    case 'SET_STRIPE_SECRET':
      return {
        ...state,
        stripeSecret: {
          secret: payload['clientSecret'],
          amount: payload['amount']
        },
      };

    case 'SET_ACTIVE_TAB':
      return {
        ...state,
        activeTab: payload,
      };

    case 'SET_DELTA_MIGRATION':
      return {
        ...state,
        newDeltaMigration: payload,
      };

    case 'SET_RECORD_COUNT':
      return {
        ...state,
        recordCount: payload['recordCount'],
        newDeltaMigration: payload['newDeltaMigration'],
        stripeSecret: {
          amount: payload['amount'],
          secret: payload['secret'],
        },
      };

    case 'SET_ATTACHMENTS_IMPORT_STATUS':
      return {
        ...state,
        attachmentsImportStatus: payload,
      };

    default:
      return state;
  }
};

export default Migration;